export const translations = {
  en: {
    nav: {
      home: 'Home'
    },
    hero: {
      title: 'Discover Tunisia',
      welcome: 'Welcome to Tunisia! Marhbe bikom fi Tounes!'
    },
    intro: {
      title: 'A Tunisian Week',
      description: 'We’ve put together a few suggestions in the surroundings of Tunis to help you plan your stay. Tunisia is a large country with a wide range of landscapes and places to explore, from coastal towns to historic sites and desert regions. Because our celebration takes place in late June, we recommend focusing on Tunis and the surrounding areas during your visit. The desert and the deep south are better suited to cooler months, while the north and coastal regions are generally more comfortable at this time of year.'
    },
    accommodations: {
      title: 'Where to Stay',
      description: 'For convenience, you may consider staying in one of the coastal areas listed below, all part of Greater Tunis, and close to the wedding venues.',
      locations: [
        {
          image: 'https://www.tourismtunisia.com/wp-content/uploads/2018/08/marsa-tunis-guide.jpg',
          name: 'La Marsa',
          description: 'Residential coastal area with restaurants and cafés, close to Sidi Bou Said. Suitable if you’d like to stay near the beach.'
        },
        {
          image: 'https://olovetunisia.com/cdn/shop/articles/sidi_bous_said_tunisia_1600x.jpg?v=1665796742',
          name: 'Sidi Bou Said',
          description: 'The well-known blue and white village itself with sea views and easy access to its streets and cafés.'
        },
        {
          image: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/292501550.jpg?k=aaaa9c589b3ee4b5b4b2f960e2efa96cf960e0d1d4dac6a33fae90ecdb883c88&o=',
          name: 'Gammarth',
          description: 'North suburb of Tunis, with several large hotels, a marina, and direct access to the coast for those who prefer staying in a resort-style setting.'
        }
      ]
    },
    itinerary: {
      title: 'Nearby places to combine',
      subtitle: 'The suggestions below group nearby places together to help reduce travel time. Focusing on one area at a time can make planning easier, especially when visiting for a limited period.',
      days: [
        {
          title: 'Coastal Charm & Ancient Ruins',
          activities: [
            {
              time: 'Morning',
              name: 'Sidi Bou Saïd',
              image: 'https://www.infotunisie.com/wp-content/uploads/2017/08/sidi-bou-said-tunisie.jpg',
              location: 'Greater Tunis',
              description: 'Explore the iconic blue and white village at a relaxed pace. You can stop at Café des Délices for a mint tea with views over the sea, walk through the village streets and small art galleries, and browse local shops selling traditional crafts. This area is easy to combine with nearby coastal spots and works well as a half-day visit.'
            },
            {
              time: 'Afternoon',
              name: 'Carthage',
              image: 'https://cdn.britannica.com/96/178496-050-CB365D03/Punic-ruins-Roman-Carthage-Tunisia.jpg',
              location: 'Greater Tunis',
              description: 'Visit the ancient Phoenician and Roman ruins of Carthage. Key sites include the Antonine Baths, Byrsa Hill, and the Roman amphitheatre. The different locations are spread out, so allowing a few hours and combining them with a visit to nearby areas works well.'
            }
          ],
          note: 'These sites are only 10 minutes apart - perfect for one day!'
        },
        {
          title: 'History & Culture in the Heart of Tunis',
          activities: [
            {
              time: 'Morning',
              name: 'Tunis Medina',
              image: 'https://c8.alamy.com/comp/2B17X9N/tunis-tunisia-local-market-at-the-medina-2B17X9N.jpg',
              location: 'Tunis',
              description: 'Spend some time in the UNESCO-listed old town of Tunis. You can walk through the souks, see the Zitouna Mosque from the outside, and browse shops selling spices, and traditional crafts. The area is lively and works well as a short visit or combined with other stops in the city.'
            },
            {
              time: 'Afternoon',
              name: 'Bardo Museum',
              image: 'https://images.unsplash.com/photo-1582555172866-f73bb12a2ab3?w=800&h=400&fit=crop',
              location: 'Tunis',
              description: 'Visit the Bardo Museum, which houses an extensive collection of Roman mosaics displayed in a former Ottoman palace. The visit typically takes around two to three hours, depending on how much time you spend in the galleries.'
            }
          ],
          note: 'Both sites are in central Tunis - easy to navigate with taxi.'
        },
        {
          title: 'Day Trip Outside Tunis',
          activities: [
            {
              time: 'Option 1',
              name: 'Hammamet',
              image: 'https://images.unsplash.com/photo-1506929562872-bb421503ef21?w=800&h=400&fit=crop',
              location: '1 hour from Tunis',
              description: 'Coastal town known for its beaches and walkable centre. You can spend time by the sea, visit the old medina and kasbah, or make use of the spa facilities available in many hotels. It works well as a relaxed stop, especially if you’re staying along the coast.'
            },
            {
              time: 'Option 2',
              name: 'Dougga',
              image: 'https://upload.wikimedia.org/wikipedia/commons/8/88/Dougga_Theatre_-_Looking_Down_from_the_Top.jpg',
              location: '2 hours from Tunis',
              description: 'Visit the Roman site of Dougga, set on a hillside overlooking the surrounding countryside. It is one of the best-preserved Roman archaeological sites in North Africa. Allow several hours for the visit, and note that it is best reached by car.'
            }
          ],
          note: 'Choose based on your preference: beach relaxation or ancient history!'
        }
      ]
    },
    tips: {
      title: 'Practical Travel Tips',
      items: [
        {
          icon: '💰',
          title: 'Currency',
          desc: 'The local currency is the Tunisian Dinar (TND). Cash is commonly used, especially in smaller shops and cafés, but card payments are often accepted in many places. ATMs are easy to find.'
        },
        {
          icon: '🗣️',
          title: 'Language',
          desc: 'Arabic is the official language, and the spoken dialect is Derja. French is widely spoken and commonly used in daily life.'
        },
        {
          icon: '🚕',
          title: 'Transportation',
          desc: 'Metered taxis are widely available for getting around Tunis and nearby areas. For longer distances, louages (shared taxis) are a common and practical option.'
        },
        {
          icon: '🌡️',
          title: 'Weather',
          desc: 'Expect generally warm and sunny weather, with daytime temperatures ranging between 20–30°C. Evenings are usually a bit cooler, which can be comfortable after a full day out.'
        },
        {
          icon: '🛍️',
          title: 'Shopping',
          desc: 'Bargaining is common in the souks and part of the experience. It’s usually best to stay polite and relaxed, make a counter-offer, and take your time. If the price doesn’t feel right, it’s perfectly fine to walk away.'
        },
        {
          icon: '🍽️',
          title: 'Food',
          desc: 'Tunisia is generally affordable, especially for food. You’ll find plenty of local dishes to try, such as couscous, grilled fish, brik, kefteji, and mint tea with tunisian pastries. Street food is common and widely enjoyed;'
        }
      ]
    },
    contact: {
      title: 'Get in Touch',
      message: 'We are happy to help if you have any questions about the wedding or practical aspects of your trip. Feel free to reach out at any time.',
      email: 'Email us',
      phone: 'Call or Whatsapp us'
    },
    footer: {
      tagline: 'We can\'t wait to celebrate with you in beautiful Tunisia! 🇹🇳',
      copyright: '2026 Fatma & Tarik Wedding'
    }
  },
  fr: {
  nav: {
    home: 'Accueil'
  },
  hero: {
    title: 'Découvrez la Tunisie',
    welcome: 'Bienvenue en Tunisie! Marhbe bikom fi Tounes!'
  },
  intro: {
    title: 'Une Semaine Tunisienne',
    description: 'Nous avons rassemblé quelques suggestions dans les alentours de Tunis pour vous aider à planifier votre séjour. La Tunisie est un grand pays avec une grande variété de paysages et de lieux à explorer, des villes côtières aux sites historiques et aux régions désertiques. Etant donné que nos célébrations auront lieu fin juin, nous recommandons de se concentrer sur Tunis et ses environs pendant votre visite. Le désert et le grand sud sont plus adaptés aux mois plus frais, tandis que le nord et les régions côtières sont généralement plus confortables à cette période de l\'année.'
  },
  accommodations: {
    title: 'Où Séjourner',
    description: 'Pour plus de commodité, vous pouvez envisager de séjourner dans l\'une des zones côtières énumérées ci-dessous, toutes faisant partie du Grand Tunis et proches des lieux du mariage.',
    locations: [
      {
        image: 'https://www.tourismtunisia.com/wp-content/uploads/2018/08/marsa-tunis-guide.jpg',
        name: 'La Marsa',
        description: 'Zone côtière résidentielle avec restaurants et cafés, proche de Sidi Bou Saïd. Idéale si vous souhaitez séjourner près de la plage.'
      },
      {
        image: 'https://olovetunisia.com/cdn/shop/articles/sidi_bous_said_tunisia_1600x.jpg?v=1665796742',
        name: 'Sidi Bou Saïd',
        description: 'Le célèbre village bleu et blanc lui-même avec vue sur la mer et accès facile à ses rues et cafés.'
      },
      {
        image: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/292501550.jpg?k=aaaa9c589b3ee4b5b4b2f960e2efa96cf960e0d1d4dac6a33fae90ecdb883c88&o=',
        name: 'Gammarth',
        description: 'Banlieue nord de Tunis, avec plusieurs grands hôtels, une marina et un accès direct à la côte pour ceux qui préfèrent séjourner dans un cadre de type station balnéaire.'
      }
    ]
  },
  itinerary: {
    title: 'Lieux proches à combiner',
    subtitle: 'Les suggestions ci-dessous regroupent des lieux proches pour réduire le temps de trajet. Se concentrer sur une zone à la fois peut faciliter la planification, surtout lors d\'une visite de courte durée.',
    days: [
      {
        title: 'Charme Côtier & Ruines Antiques',
        activities: [
          {
            time: 'Matin',
            name: 'Sidi Bou Saïd',
            image: 'https://www.infotunisie.com/wp-content/uploads/2017/08/sidi-bou-said-tunisie.jpg',
            location: 'Grand Tunis',
            description: 'Explorez le village emblématique bleu et blanc à un rythme détendu. Vous pouvez vous arrêter au Café des Délices pour un thé à la menthe avec vue sur la mer, vous promener dans les rues du village et les petites galeries d\'art, et parcourir les boutiques locales vendant de l\'artisanat traditionnel. Cette zone se combine facilement avec les endroits côtiers voisins et convient bien pour une visite d\'une demi-journée.'
          },
          {
            time: 'Après-midi',
            name: 'Carthage',
            image: 'https://cdn.britannica.com/96/178496-050-CB365D03/Punic-ruins-Roman-Carthage-Tunisia.jpg',
            location: 'Grand Tunis',
            description: 'Visitez les anciennes ruines phéniciennes et romaines de Carthage. Les sites clés incluent les Thermes d\'Antonin, la colline de Byrsa et l\'amphithéâtre romain. Les différents emplacements sont dispersés, donc prévoir quelques heures et les combiner avec une visite des zones voisines fonctionne bien.'
          }
        ],
        note: 'Ces sites sont à seulement 10 minutes l\'un de l\'autre - parfait pour une journée!'
      },
      {
        title: 'Histoire & Culture au Cœur de Tunis',
        activities: [
          {
            time: 'Matin',
            name: 'Médina de Tunis',
            image: 'https://c8.alamy.com/comp/2B17X9N/tunis-tunisia-local-market-at-the-medina-2B17X9N.jpg',
            location: 'Tunis',
            description: 'Passez du temps dans la vieille ville classée UNESCO de Tunis. Vous pouvez vous promener dans les souks, voir la mosquée Zitouna de l\'extérieur et parcourir les boutiques vendant des épices et de l\'artisanat traditionnel. La zone est animée et convient bien pour une courte visite ou combinée avec d\'autres arrêts dans la ville.'
          },
          {
            time: 'Après-midi',
            name: 'Musée du Bardo',
            image: 'https://images.unsplash.com/photo-1582555172866-f73bb12a2ab3?w=800&h=400&fit=crop',
            location: 'Tunis',
            description: 'Visitez le musée du Bardo, qui abrite une vaste collection de mosaïques romaines exposées dans un ancien palais ottoman. La visite dure généralement environ deux à trois heures, selon le temps que vous passez dans les galeries.'
          }
        ],
        note: 'Les deux sites sont dans le centre de Tunis - faciles d\'accès en taxi.'
      },
      {
        title: 'Excursion d\'une Journée Hors de Tunis',
        activities: [
          {
            time: 'Option 1',
            name: 'Hammamet',
            image: 'https://images.unsplash.com/photo-1506929562872-bb421503ef21?w=800&h=400&fit=crop',
            location: '1 heure de Tunis',
            description: 'Ville côtière connue pour ses plages et son centre accessible à pied. Vous pouvez passer du temps au bord de la mer, visiter la vieille médina et la kasbah, ou profiter des installations de spa disponibles dans de nombreux hôtels. C\'est une étape relaxante, surtout si vous séjournez le long de la côte.'
          },
          {
            time: 'Option 2',
            name: 'Dougga',
            image: 'https://upload.wikimedia.org/wikipedia/commons/8/88/Dougga_Theatre_-_Looking_Down_from_the_Top.jpg',
            location: '2 heures de Tunis',
            description: 'Visitez le site romain de Dougga, situé sur une colline surplombant la campagne environnante. C\'est l\'un des sites archéologiques romains les mieux préservés d\'Afrique du Nord. Prévoyez plusieurs heures pour la visite, et notez qu\'il est préférable d\'y accéder en voiture.'
          }
        ],
        note: 'Choisissez selon votre préférence: détente à la plage ou histoire antique!'
      }
    ]
  },
  tips: {
    title: 'Conseils Pratiques de Voyage',
    items: [
      {
        icon: '💰',
        title: 'Monnaie',
        desc: 'La monnaie locale est le Dinar Tunisien (TND). L\'argent liquide est couramment utilisé, en particulier dans les petits magasins et cafés, mais les paiements par carte sont souvent acceptés dans de nombreux endroits. Les distributeurs automatiques sont faciles à trouver.'
      },
      {
        icon: '🗣️',
        title: 'Langue',
        desc: 'L\'arabe est la langue officielle, et le dialecte parlé est la Derja. Le français est largement parlé et couramment utilisé dans la vie quotidienne.'
      },
      {
        icon: '🚕',
        title: 'Transport',
        desc: 'Les taxis à compteur sont largement disponibles pour se déplacer dans Tunis et les zones voisines. Pour les longues distances, les louages (taxis partagés) sont une option courante et pratique.'
      },
      {
        icon: '🌡️',
        title: 'Météo',
        desc: 'Attendez-vous à un temps généralement chaud et ensoleillé, avec des températures diurnes variant entre 20 et 30°C. Les soirées sont généralement un peu plus fraîches, ce qui peut être agréable après une journée complète.'
      },
      {
        icon: '🛍️',
        title: 'Shopping',
        desc: 'Le marchandage est courant dans les souks et fait partie de l\'expérience. Il est généralement préférable de rester poli et détendu, de faire une contre-offre et de prendre son temps. Si le prix ne vous convient pas, il est parfaitement acceptable de partir.'
      },
      {
        icon: '🍽️',
        title: 'Nourriture',
        desc: 'La Tunisie est généralement abordable, surtout pour la nourriture. Vous trouverez de nombreux plats locaux à essayer, tels que le couscous, le poisson grillé, le brik, le kefteji et le thé à la menthe avec des pâtisseries tunisiennes. La nourriture de rue est courante et largement appréciée.'
      }
    ]
  },
  contact: {
    title: 'Nous Contacter',
    message: 'Nous sommes heureux de vous aider si vous avez des questions sur le mariage ou les aspects pratiques de votre voyage. N\'hésitez pas à nous contacter à tout moment.',
    email: 'Envoyez-nous un email',
    phone: 'Appelez-nous ou Whatsapp'
  },
  footer: {
    tagline: 'Nous avons hâte de célébrer avec vous dans la belle Tunisie! 🇹🇳',
    copyright: '2026 Mariage Fatma & Tarik'
  }
}
};